import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import { connect } from 'react-redux';
import types from 'prop-types';
import { mapProps } from 'recompose';
var withA11y = mapProps(function (_ref) {
  var appLayer = _ref.appLayer,
      layer = _ref.layer,
      props = _objectWithoutProperties(_ref, ["appLayer", "layer"]);

  return _objectSpread({}, props, {
    tabIndex: appLayer === layer ? 0 : -1
  });
});
export default withA11y;
export var withAppLayer = connect(function (_ref2) {
  var layer = _ref2.ui.layer;
  return {
    appLayer: layer
  };
});
export var propTypes = {
  appLayer: types.number,
  layer: types.number
};